module.exports = __webpack_public_path__ + "img/Logo_Lila_mc.3ab460de.png";